import gql from 'graphql-tag'

export const GRUPOS_USUARIOS_ATIVOS_QUERY = gql`
  query gruposUsuariosQuery {
    gruposUsuariosAtivos {
      id
      nome
      publico
      favorito
    }
  }
`
